import { render } from "./customBoard.vue?vue&type=template&id=057516c2"
import script from "./customBoard.vue?vue&type=script&lang=js"
export * from "./customBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__